import type { IFaqCategory } from './faq-types';

export const faqTroubleshooting: IFaqCategory = {
  title: 'Troubleshooting',
  slug: 'troubleshooting',
  items: [
    {
      question: 'The app is crashing. What should I do?',
      answer:
        'Try closing and reopening the app. If the issue persists, make sure you have the latest version installed from the App Store or Google Play. Restarting your device can also help. If the problem continues, contact us with your device model, OS version, and app version.',
    },
    {
      question: 'How do I report a bug?',
      answer:
        'You can report a bug directly from the app using the support feature in the Profile tab, or email us at hi@yocoolmate.com. Please include your device model, operating system version, app version, and a description of the issue.',
    },
  ],
};
